<template>
    <div class='bto-sb-widget-slider' :style="!filteredItems || !filteredItems.length ? 'min-height: 100px;' : null"
         v-if="filteredItems.length">
        <div ref='slider' class='bto-sb-slider'>
            <div
                    ref='itemWrapper'
                    class='bto-sb-slider-item-wrapper'
                    :class='`bto-sb-slider-effect-${effect}`'
                    :style='effect === `slide` ? `width: ${filteredItems.length * (100 / itemsPerPage)}%` : null'
            >
                <div
                        ref='sliderItems'
                        v-for='(item, idx) in links'
                        :key='idx'
                        class='bto-sb-slider-item'
                        :style='effect === `slide` ? `width: ${100 / links.length}%` : currentSlide === idx ? null : `display: none;`'
                >
                    <component :is="item.component" v-bind="item.props">
                        <img
                                v-if="item.imgUrl"
                                :src='item.imgUrl'
                        />
                    </component>
                </div>
            </div>
            <div class='bto-sb-slider-ui bto-sb-slider-arrow bto-sb-arrow-left' @click="goToSlide(getPreviousN())">
                &#xE91C;
            </div>
            <div class='bto-sb-slider-ui bto-sb-slider-arrow bto-sb-arrow-right' @click="goToSlide(getNextN())">
                &#xE91D;
            </div>
            <div class='bto-sb-slider-dots-wrapper'>
                <div
                        v-for='(dot, idx) in filteredItems.length'
                        :key='idx'
                        class='bto-sb-slider-ui bto-sb-slider-dot'
                        :class="{'bto-sb-slider-dot-active' : currentSlide === idx}"
                        @click='goToSlide(idx)'
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
  import { getLinkProps } from '@bto-services/quick-links';

  export default {
    name: 'ContentSliderWidget',
    data() {
      return {
        sliderId: undefined,
        currentSlide: 0,
        intervalId: undefined,
        transitionStyle: undefined,
        filteredItems: [],
      };
    },
    props: {
      items: {
        fieldType: 'slider-items',
        default: () => [],
        label: 'Slider items'
      },
      itemsPerPage: {
        fieldType: 'number',
        default: '1',
        label: 'Items per page',
      },
      autoplayEnabled: {
        fieldType: 'boolean',
        default: true,
        label: 'Autoplay enabled',
      },
      autoplayTimeout: {
        fieldType: 'number',
        default: '4000',
        label: 'Autoplay timeout (ms)',
      },
      effect: {
        fieldType: 'string',
        default: 'slide',
        label: "Transition effect ('slide' or 'fade')"
      },
      transitionTime: {
        fieldType: 'number',
        default: '400',
        label: 'Transition time (ms)'
      },
      loop: {
        fieldType: 'boolean',
        default: true,
        label: 'Loop items',
      },
    },
    computed: {
      links() {
        return this.filteredItems.map(l=> getLinkProps({iconUrl: l.src,label: '',link: l.link,target: l.target}));
      },
    },
    created() {
      const tmpItem = [{
        type: 'image',
        src: `${APP_SETTINGS.path.appUrl}images/slider.png`,
        name: '',
        locale: '',
        target: '_blank',
      }];
      const filtered = this.items.filter(item => typeof item.locale === 'undefined' || item.locale === '' || item.locale === APP_SETTINGS.player.language);
      this.filteredItems = filtered.length > 0 ? filtered : tmpItem;
    },
    mounted() {
      this.sliderId = Math.floor((Math.random() * Number.MAX_SAFE_INTEGER) + 1);

      if (!this.filteredItems || !this.filteredItems.length) {
        return;
      }

      if (this.autoplayEnabled) {
        this.resetAutoplay();
      }

      if (this.effect !== 'slide' && this.itemsPerPage !== 1) {
        // console.error("items per page parameter can only be set on 'slide' effect type") // eslint-disable-line
      }

      this.transitionStyle = `${this.transitionTime / 1000}s ease-out `;
      switch (this.effect) {
        case 'slide':
          this.$refs.itemWrapper.style.transition = this.transitionStyle + 'transform';
          break;
        case 'fade':
          this.$refs.sliderItems.forEach(sliderItem => {
            sliderItem.style.transition = this.transitionStyle + 'opacity';
          });
          break;
        default:
          console.error('valid effect type must be specified'); // eslint-disable-line
          break;
      }

      if (this.loop) {
        let sliderElement = this.$refs.itemWrapper.parentNode;

        let clone = this.$refs.itemWrapper.cloneNode(true);
        clone.id = `clone-left-${this.sliderId}`;
        clone.style.position = 'absolute';
        clone.style.top = 0;
        clone.style.right = '100%';
        sliderElement.appendChild(clone);

        clone = clone.cloneNode(true);
        clone.id = `clone-right-${this.sliderId}`;
        clone.style.right = null;
        clone.style.left = '100%';
        sliderElement.appendChild(clone);
      }
    },
    methods: {
      getNextN() {
        return this.currentSlide + 1 < this.filteredItems.length ? this.currentSlide + 1 : 0;
      },
      getPreviousN() {
        return this.currentSlide - 1 >= 0 ? this.currentSlide - 1 : this.filteredItems.length - 1;
      },
      resetElementTransform(element) {
        if (element) {
          element.style.transition = null;
          element.style.transform = null;
          void element.offsetWidth;
          element.style.transition = this.transitionStyle;
        }
      },
      goToSlide(n, calledFromAutoplay) {
        if (this.autoplayEnabled && !calledFromAutoplay) {
          this.resetAutoplay();
        }

        switch (this.effect) {
          case 'slide': {
            let slideWidth = this.$refs.sliderItems[0].getBoundingClientRect().width;
            let slidingOverride = false;

            if (this.loop) {
              let rightClone = document.getElementById(`clone-right-${this.sliderId}`);
              let leftClone = document.getElementById(`clone-left-${this.sliderId}`);
              let maxN = this.filteredItems.length - 1;

              if (this.currentSlide === maxN && n === 0) {
                // console.warn('last -> first');
                n = maxN + 1;
                rightClone.style.transform = `translateX(${-1 * slideWidth * this.itemsPerPage}px)`;
                slidingOverride = true;
                setTimeout(() => {
                  [rightClone, this.$refs.itemWrapper].forEach(element => {
                    this.resetElementTransform(element);
                  });

                  this.currentSlide = 0;
                }, this.transitionTime);
              } else if (this.currentSlide === 0 && n === maxN) {
                // console.warn('last <- first');
                n = -1;
                leftClone.style.transform = `translateX(${slideWidth}px)`;
                slidingOverride = true;
                setTimeout(() => {
                  this.resetElementTransform(leftClone);

                  rightClone.style.transition = null;
                  rightClone.style.transform = `translateX(${-1 * slideWidth * (this.itemsPerPage - 1)}px)`;
                  void rightClone.offsetWidth;
                  rightClone.style.transition = this.transitionStyle;

                  this.$refs.itemWrapper.style.transition = null;
                  this.$refs.itemWrapper.style.transform = `translateX(${-1 * slideWidth * maxN}px)`;
                  void this.$refs.itemWrapper.offsetWidth;
                  this.$refs.itemWrapper.style.transition = this.transitionStyle;

                  this.currentSlide = maxN;
                }, this.transitionTime);
              } else if (this.filteredItems.length - n < this.itemsPerPage) {
                // console.warn('approaching end');
                rightClone.style.transform = `translateX(${-1 * slideWidth * (this.itemsPerPage - (this.filteredItems.length - n))}px)`;
              } else {
                rightClone.style.transform = null;
                leftClone.style.transform = null;
              }
            }

            this.$refs.itemWrapper.style.transform = `translateX(${-1 * slideWidth * n}px)`;
            if (!slidingOverride) {
              setTimeout(() => {
                this.currentSlide = n;
              }, this.transitionTime);
            }
            break;
          }
          case 'fade': {
            let nextSlide = this.$refs.sliderItems[n];
            nextSlide.style.display = 'block';
            nextSlide.style.position = 'absolute';
            nextSlide.style.left = 0;
            nextSlide.style.top = 0;

            nextSlide.style.transition = null;
            void nextSlide.offsetWidth;
            nextSlide.style.opacity = 0;
            void nextSlide.offsetWidth;
            nextSlide.style.transition = this.transitionStyle;

            nextSlide.style.opacity = 1;
            this.$refs.sliderItems[this.currentSlide].style.opacity = 0;
            setTimeout(() => {
              nextSlide.style.position = null;
              nextSlide.style.left = null;
              nextSlide.style.top = null;
              nextSlide.style.opacity = null;
              this.$refs.sliderItems[this.currentSlide].style.opacity = null;

              this.currentSlide = n;
            }, this.transitionTime);
            break;
          }
          default:
            console.error('valid effect type must be specified'); // eslint-disable-line
            break;
        }
      },
      resetAutoplay() {
        this.intervalId && clearInterval(this.intervalId);
        this.intervalId = setInterval(() => {
          this.goToSlide(this.getNextN(), true);
        }, this.autoplayTimeout);
      },
    },
    beforeDestroy() {
      this.intervalId && clearInterval(this.intervalId);
    },
  };
</script>
